// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-post-button-wrapper {
  display: flex;
  align-items: center;
  height: 100vh;
  position: fixed;
  left: 12px;
  width: auto;
  flex-direction: column;
  top: 0px;
  gap: 8px;
  justify-content: center;
}
.campaign-post-button-wrapper.campaign-post-button-wrapper-right-position {
  left: auto;
  right: 12px;
}
.campaign-post-button-wrapper.campaign-post-button-wrapper-right-position .campaign-button-content-details {
  right: 12px;
  left: auto;
}
.campaign-post-button-wrapper.campaign-post-button-wrapper-right-position .campaign-button-content-details .button-maintain {
  left: auto;
  right: -44px;
}
.campaign-post-button-wrapper.campaign-post-button-wrapper-right-position .campaign-button-content-details .content-campaign-more-info {
  margin: 0 44px 0 0;
  right: 0;
}
.campaign-post-button-wrapper .campaign-button-content-details {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 999;
  width: 100%;
  height: auto;
  max-height: 100%;
  min-height: 125px;
}
.campaign-post-button-wrapper .campaign-button-content-details.show-campaign-content-data .content-campaign-more-info {
  display: block;
}
.campaign-post-button-wrapper .campaign-button-content-details .button-maintain {
  border-radius: 8px;
  border: 1px solid var(--Primary-600, #155EEF);
  background: var(--Primary-600, #155EEF);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  transform: rotate(90deg);
  padding: 8px 12px;
  height: 36px;
  flex-shrink: 0;
  position: absolute;
  left: -43px;
  top: auto;
  width: 125px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--Base-White, #FFF);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
}
.campaign-post-button-wrapper .campaign-button-content-details .content-campaign-more-info {
  margin: 0 0 0 44px;
  border-radius: 12px;
  background: var(--Base-White, #FFF);
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  width: 300px;
  height: auto;
  padding: 24px;
  position: absolute;
  top: auto;
  display: none;
}
.campaign-post-button-wrapper .campaign-button-content-details .content-campaign-more-info .heading-block-info {
  display: flex;
  align-items: center;
  gap: 10px;
  overflow: hidden;
  margin-bottom: 16px;
}
.campaign-post-button-wrapper .campaign-button-content-details .content-campaign-more-info .heading-block-info img {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  border-radius: 100%;
}
.campaign-post-button-wrapper .campaign-button-content-details .content-campaign-more-info .heading-block-info h1 {
  color: var(--Gray-400, #98A2B3);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0;
}
.campaign-post-button-wrapper .campaign-button-content-details .content-campaign-more-info .heading-block-info button {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
}
.campaign-post-button-wrapper .campaign-button-content-details .content-campaign-more-info p {
  color: var(--Gray-900, #101828);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 16px 0;
  word-break: break-word;
}
.campaign-post-button-wrapper .campaign-button-content-details .content-campaign-more-info a {
  color: var(--Primary-600, #155EEF);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-decoration-line: underline;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/plugins/proactiveWebCampaign/templates/pwcButtonTemplate/pwcButtonTemplate.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,QAAA;EACA,uBAAA;AAAJ;AACI;EACI,UAAA;EACA,WAAA;AACR;AAAQ;EACI,WAAA;EACA,UAAA;AAEZ;AADY;EACI,UAAA;EACA,YAAA;AAGhB;AADY;EACI,kBAAA;EACA,QAAA;AAGhB;AACI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AACR;AACY;EACI,cAAA;AAChB;AAEQ;EACI,kBAAA;EACA,6CAAA;EACA,uCAAA;EACA,kDAAA;EACA,wBAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAAZ;AAEQ;EACI,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,8FAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;AAAZ;AACY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAChB;AAAgB;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAEpB;AAAgB;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAEpB;AAAgB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAEpB;AACY;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AAChB;AACY;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,SAAA;AAChB","sourcesContent":["\n.campaign-post-button-wrapper{\n    display: flex;\n    align-items: center;\n    height: 100vh;\n    position: fixed;\n    left: 12px;\n    width: auto;\n    flex-direction: column;\n    top: 0px;\n    gap: 8px;\n    justify-content: center;\n    &.campaign-post-button-wrapper-right-position{\n        left: auto;\n        right: 12px;\n        .campaign-button-content-details{\n            right: 12px;\n            left: auto;\n            .button-maintain{\n                left: auto;\n                right: -44px;\n            }\n            .content-campaign-more-info{\n                margin: 0 44px 0 0;\n                right: 0;\n            }\n        }\n    }\n    .campaign-button-content-details{\n        display: flex;\n        align-items: center;\n        position: relative;\n        z-index: 999;\n        width: 100%;\n        height: auto;\n        max-height: 100%;\n        min-height: 125px;\n        &.show-campaign-content-data{\n            .content-campaign-more-info{\n                display: block;\n            }\n        }\n        .button-maintain{\n            border-radius: 8px;\n            border: 1px solid var(--Primary-600, #155EEF);\n            background: var(--Primary-600, #155EEF);\n            box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n            transform: rotate(90deg);\n            padding: 8px 12px;\n            height: 36px;\n            flex-shrink: 0;\n            position: absolute;\n            left: -43px;\n            top: auto;\n            width: 125px;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            color: var(--Base-White, #FFF);\n            font-size: 14px;\n            font-weight: 500;\n            line-height: 20px;\n            cursor: pointer;\n        }\n        .content-campaign-more-info{\n            margin: 0 0 0 44px;\n            border-radius: 12px;\n            background: var(--Base-White, #FFF);\n            box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08);\n            width: 300px;\n            height: auto;\n            padding: 24px;\n            position: absolute;\n            top: auto;\n            display: none;\n            .heading-block-info{\n                display: flex;\n                align-items: center;\n                gap: 10px;\n                overflow: hidden;\n                margin-bottom: 16px;\n                img{\n                    flex-shrink: 0;\n                    width: 14px;\n                    height: 14px;\n                    border-radius: 100%;\n                }\n                h1{\n                    color: var(--Gray-400, #98A2B3);\n                    font-size: 12px;\n                    font-weight: 500;\n                    line-height: 18px;\n                    width: 100%;\n                    overflow: hidden;\n                    white-space: nowrap;\n                    text-overflow: ellipsis;\n                    margin: 0;\n                }\n                button{\n                    width: 24px;\n                    height: 24px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    padding: 0;\n                    border: 0;\n                    background: transparent;\n                    cursor: pointer;\n                    flex-shrink: 0;\n                }\n            }\n            p{\n                color: var(--Gray-900, #101828);\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 20px;\n                margin: 16px 0;\n                word-break: break-word;\n            }\n            a{\n                color: var(--Primary-600, #155EEF);\n                font-size: 14px;\n                font-weight: 500;\n                line-height: 20px;\n                text-decoration-line: underline;\n                margin: 0;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
